import type { Pos } from '../../lib/replay';
import { fmtTime } from '../../lib/format';

export default function HUD({ pos, crossM, runway, wind }: { pos: Pos | null; crossM: number | null; runway: string | null; wind: string | null }) {
  if (!pos) return null;
  const row = (k: string, v: string) => <div className="flex justify-between gap-4"><span className="text-dim">{k}</span><span>{v}</span></div>;
  return (
    <div className="absolute left-3 top-3 z-10 hud text-[13px] leading-5 bg-ink/80 border border-line rounded-md px-3 py-2 min-w-[190px] backdrop-blur">
      <div className="text-amber font-semibold mb-1">{fmtTime(pos.ts)} · {pos.phase?.replace('_', ' ') ?? '—'}</div>
      {row('ALT AF', `${Math.round(pos.hAF)} ft`)}
      {row('GS', `${Math.round(pos.gs)} kt`)}
      {row('VS', `${pos.vs >= 0 ? '+' : ''}${Math.round(pos.vs / 10) * 10} fpm`)}
      {row('TRK', `${String(Math.round(pos.track)).padStart(3, '0')}°`)}
      {crossM !== null && row(`X-TRK ${runway ?? ''}`, `${crossM >= 0 ? 'R' : 'L'} ${Math.round(Math.abs(crossM))} m`)}
      {wind && row('WIND', wind)}
    </div>
  );
}
